import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { SERVICE_STATUS_TYPE } from '../../../../util/constant';
import { loggedInUser } from '../../../../store/reducers/account_reducer';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../../../../util/helper';
import { Link } from 'react-router-dom';
import { setBreadCrumb } from '../../../../store/reducers/menu_reducer';
import { getUpcomingServices } from '../../../../services/mm/apiController';
import { factoryId } from '../../../../store/reducers/account_reducer';

const UpcomingDue = () => {
  const [list, setList] = useState(null);
  let user = useSelector(loggedInUser);
  const dispatch = useDispatch();
  const factoryId_ = useSelector(factoryId);

  useEffect(() => {
    getAUpcoming();
  }, [factoryId_]);

  const getAUpcoming = async () => {
    const upcomingService = await getUpcomingServices(factoryId_, "PENDING", 1);
    setList(upcomingService.data);
  };

  useEffect(() => {
    if (user && user.factoryId) {
      axios
        .get(`/installation/getDues`, {
          params: {
            status: SERVICE_STATUS_TYPE.PENDING,
            days: 1,
            factoryId: (user && user.factoryId) || null,
          },
        })
        .then((resp) => {
          setList(resp && resp.data && resp.data.data);
        })
        .catch((error) => {
          setList(null);
        });
    }
  }, [user]);

  const breadCrumbChanges = (id) => {
    dispatch(
      setBreadCrumb({
        label: 'Installation Detail',
        value: `/installations/${id}`,
      })
    );
  };

  return (
    <React.Fragment>
      <div className="header-title">Upcoming Services</div>
      <div className="card">
        <div className="card-body p-0">
          {(!list || list.length === 0) && (
            <div className="alert alert-warning mb-0" role="alert">
              <strong>No data available</strong>
            </div>
          )}
          {list && list.length > 0 && (
            <div className="table-responsive">
              <table className="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Machine</th>
                    <th>Asset #</th>
                    <th>Section</th>
                    <th>Service Info</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.item}</td>
                        <td>
                          <Link to={`/mm/installation/${item?.id}/?activeTab=service-remainder`}>
                            <span onClick={() => breadCrumbChanges(item.id)}>{item?.itemNumber}</span>
                          </Link>
                        </td>
                        <td>{item.section}</td>
                        <td>
                          <ul className="list-group list-group-flush">
                          {item.service_remainders.map((item)=> {
                          return (
                            <li className="list-group-item p-0">
                              <p className="mb-0">{item?.name}</p>
                              <p className="mb-0">{item?.description}</p>
                              <p className="mb-0">{formatDate(item.dueDate)}</p>
                            </li>
                            );
                          })}
                          </ul>  
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {/* <pre>{JSON.stringify(list, null, 4)}</pre> */}
    </React.Fragment>
  );
};

export default UpcomingDue;
